const login = {
    "login": "로그인",
    "phone": "휴대전화",
    "email": "이메일",
    "erCode": "QR 코드",
    "phoneNo": "전화번호",
    "sryx": "이메일을 입력하세요",
    "password": "비밀번호",
    "wjmm": "비밀번호를 잊으셨나요?",
    "srmm": "비밀번호를 입력하세요",
    "myzh": "계정이 없으신가요?",
    "ljzc": "지금 가입하기",
    "cxsm": "새로 고친 후 Biking 앱을 사용하여 다시 스캔하십시오.",
    "xydl": "모바일에서 로그인 확인",
    "smewm": "Biking 앱에서 개인 정보 아이콘을 클릭 한 다음 오른쪽 상단 아이콘을 클릭하여 QR 코드를 스캔하십시오.",
    "qtfs": "다른 방법으로 로그인",
    "ggsfyz": "구글 인증",
    "bdsj": "전화 번호가 이미 바인딩되어 있습니다.",
    "bdyx": "이메일이 이미 바인딩되어 있습니다.",
    "fsyzm": "보내다",
    "wcyz": "인증을 완료하십시오",
    "dlcg": "로그인이 성공적으로 완료되었습니다. Biking을 환영합니다!",
    "bktb": "계정 보안 설정 변경 후 24 시간 이내에 출금이 불가능합니다.",
    "fhdl": "로그인 페이지로 돌아가기",
    "jx": "계속",
    "cxfs": "재전송",
    "gxmm": "비밀번호 업데이트",
    "srsjh": "전화 번호를 입력하세요",
    "wjmm1": "비밀번호를 잊으셨나요?",
    "sryxdz": "이메일 주소를 입력하세요",
    "srzqyx": "올바른 이메일 주소를 입력하세요",
    "sryzm": "인증 코드 입력",
    "czmm": "비밀번호 재설정",
    "sbdyzm": "인증 코드를 받지 못하셨나요?",
    "srxmm": "새로운 비밀번호 입력",
    "zczh": "Biking 계정 등록",
    "yqm": "초대 코드(선택 사항)",
    "sryqm": "초대 코드를 입력하세요",
    "zc": "등록",
    "yyzh": "이미 계정이 있으신가요?",
    "ljdl": "지금 로그인",
    "fsz": "인증 코드가 다음으로 전송되었습니다",
    "next": "다음",
    "szmm": "비밀번호 설정",
    "submit": "제출",
    "zccg": "등록 성공!"
  }
  const download = {
    "title": "다양한 게임 및<br/>암호화폐 거래 플랫폼",
    "subTitle": "비킹은 100 가지 이상의 암호화폐 거래를 지원합니다.",
    "xzbw": "왜 비킹을 선택해야 하나요?",
    "czzz": "BiKing은 재산 창출, 가치 증대 및 재산 보호를 돕습니다.",
    "download": "App Store 다운로드",
    "downloadtf": "TestFlight 다운로드",
    "cjqxz": "슈퍼 서명 다운로드",
    "cjq": "슈퍼 서명 {index}",
    "bdxz": "로컬 다운로드",
    "ggpxz": "Google Play 다운로드",
    "advantageTitle1": "최고 성능 · 초고속 거래",
    "subTitleSubTitle1": "런던 증권 거래소 기술로 구동되며, 초저 지연 시간과 초고 속 거래를 제공합니다.",
    "advantageTitle2": "자산 보호 · 최고 수준의 보안",
    "subTitleSubTitle2": "비킹은 CCSS 표준을 준수하여 자산 및 데이터의 안전을 보장합니다.",
    "advantageTitle3": "24시간 서비스",
    "subTitleSubTitle3": "시스템이 정상 작동되고 24시간 고객 서비스를 제공합니다.",
    "qhidxq": "ID 세부 정보 변경",
    "step1": "1단계",
    "step2": "2단계",
    "step3": "3단계",
    "step4": "4단계",
    "step5": "5단계",
    "step6": "6단계",
    "step7": "7단계",
    "step8": "8단계",
    "step9": "9단계",
    "step10": "10단계",
    "azBiking": "App Store에서 BiKing 설치",
    "dlxz": "대중국 본토 이외의 App ID가 있는 경우 직접 App Store에서 다운로드하십시오.",
    "fdlid": "대중국 본토 이외의 App ID를 준비하세요.",
    "yxfshq": "대중국 본토 이외의 App ID가 없는 경우 다음 방법으로 시도할 수 있습니다.",
    "qhid": "App Store에서 Apple ID 변경",
    "dk": "1.열기",
    "ysjtx": "App Store 앱을 열고, 오른쪽 상단의 App Store 아이콘을 클릭하세요.",
    "cxsrmm": "2.로그아웃을 클릭하여 Apple ID와 비밀번호를 다시 입력하세요.",
    "wfdl": "* 로그인하지 못할 경우, 최근 로그인 빈도가 너무 높은 경우일 수 있습니다. ID를 변경하거나 몇 시간 후에 다시 시도하십시오. ID가 잠겼으면 확인이나 ID를 변경한 후 다시 시도하십시오.",
    "azapp": "앱 설치",
    "storesh": "1.로그인 성공 후, 해당 지역의 App Store로 자동 이동하여 'BiKing'을 검색하고 'Get' 버튼을 클릭하여 앱을 설치하십시오.",
    "jxxz": "나는 대중국 본토 이외의 Apple ID를 가지고 있습니다. 계속해서 다운로드하십시오.",
    "jxxz1": "계속 다운로드",
    "way1": "방법 1",
    "wayTitle1": "직접 등록하여 안정적으로",
    "wayBtn1": "등록 방법 확인",
    "way2": "방법 2",
    "wayTitle2": "플랫폼 참조 ID(편리하고 빠름)",
    "wayBtn2": "참조 ID 보기",
    "way3": "방법 3",
    "wayTitle3": "국가/지역 가이드(자유로운 변경)",
    "wayBtn3": "구매 방법 보기",
    "ckzh": "중국 본토가 아닌 Apple ID 참조 계정",
    "jgck": "다음 해외 지역 ID를 참조로 사용하십시오.",
    "jjfz": "(계정 또는 비밀번호를 클릭하면 직접 복사됩니다.)",
    "zh": "계정",
    "mm": "비밀번호",
    "xxxl": "당신의 휴대폰 정보 유출을 막기 위해",
    "dlicloud": "위의 Apple ID로 iCloud에 로그인하지 마십시오.",
    "tczh": "참조 Apple ID를 사용하여 앱을 다운로드 한 후에는 즉시 해당 계정에서 로그 아웃하십시오.",
    "cfsy": "휴대폰 번호를 바인딩하지 마십시오. 그렇지 않으면 ID를 재사용할 수 없습니다.",
    "jrql": "QR 코드를 스캔하여 그룹 채팅에 참여하세요.",
    "lxkf": "고객 서비스에 문의하세요.",
    "zjzc": "해외 ID 직접 등록",
    "registerStep1": "1단계 Apple ID 홈페이지를 엽니다.",
    "registerStep2": "2단계 이메일 확인",
    "registerStep3": "3단계 App Store 계정 로그 아웃",
    "registerStep4": "4단계 Store에서 새로 등록한 ID로 로그인",
    "gwzcwz": "Safari 브라우저에서 Apple 공식 웹 사이트 등록 URL을 엽니다.",
    "yzdzyx": "모든 정보를 작성하고 계속을 클릭하면 이메일로 Apple ID 확인 코드가 전송됩니다. 이메일 확인 코드를 입력해야 합니다.",
    "tjfkfs": "그러면 자동으로 Apple ID 관리 페이지로 이동하고(로드에 시간이 걸릴 수 있음) 관리 페이지로 이동한 후 결제 및 배송을 클릭하고 다음 페이지에서 결제 방법 추가를 클릭하십시오.",
    "mgsfzsc": "이제 가장 중요한 순간입니다. 결제 방법이 '없음'인지 확인하고 국가/지역이 미국 또는 등록하려는 국가/지역인지 확인하십시오. 기타 정보는 임의로 입력할 수 있습니다. 그러나 영어로 입력하는 것이 좋으며, 주/시는 알래스카를 선택하십시오. 이 지역은 면세이며 앱 구매도 면세입니다. 구체적인 개인 정보 입력은 웹 사이트에서 생성할 수 있습니다: 미국 신분증 생성",
    "gxdqxx": "입력이 완료되면 업데이트를 클릭하여 지역 정보를 업데이트하십시오.",
    "zhxx": "1. App Store에 들어가서 오른쪽 상단의 프로필 아이콘을 클릭하여 계정 페이지로 이동합니다.",
    "djwc": "2. 이 페이지를 맨 아래로 스크롤하여 '로그 아웃'을 클릭하여 상점 ID에서 로그 아웃하고 '완료'를 클릭하세요.",
    "jrzhdl": "1. 다시 오른쪽 상단의 프로필 아이콘을 클릭하여 계정 로그인 페이지로 이동합니다.",
    "zhmmdl": "2. 계정 및 비밀번호를 입력하고 '로그인'을 클릭하여 로그인합니다.",
    "jydlcg": "3. 인증 코드를 입력하고 확인하면 Apple ID로 성공적으로 로그인합니다.",
    "jysssd": "언제 어디서나 거래하세요.",
    "smewm": "QR 코드를 스캔하십시오.",
    "xiazai": "다운로드",
    "huodong": "활동",
    "title1": "Biking 다양한 게임",
    "title2": "및 암호화폐 거래 플랫폼",
    "open": "“Biking” 앱에서 열기",
    "ggzx": "공지 센터",
    "lscb": "체인 입금",
    "fbrj": "법화 입금",
    "tgaq": "사용자에게 보다 안전한 환경을 제공합니다.",
    "wdjmzc": "안정적인 암호화폐 파생상품 거래 서비스",
    "szhbjy": "우리는 암호화폐 거래에 전문화되어 있습니다.",
    "yxhsjh": "이메일/전화 번호를 통해 등록하세요."
  }
  export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/kr.js